import {
  createEvent,
  createStore,
  merge,
  sample,
  guard,
  combine
} from '@effector/effector'
import {h, style, attr, data, list, text, nodeMethod} from '../h'
import {section} from './section'
import {reshape} from '../../reshape'
import {HighlightValue} from '../highlight/Highlight'
import {
  timelineRows,
  timelineLookaheadOffset,
  timelineLegend,
  timelineItems,
  timelineLegendSmall,
  getOffset,
  VISIBLE_SIZE
} from './timeline'

export function Timeline() {
  section('timeline', () => {
    data({codeStylistic: 'black'})
    h('header', () => {
      data({appgridHeader: 'timeline'})
      h('h4', {
        text: 'Timeline'
      })
    })
    h('section', () => {
      data({timelineNames: true})
      list(timelineRows, ({store}) => {
        h('div', {
          data: {timelineName: true},
          text: store
        })
      })
    })
    h('section', () => {
      const scrollTo = nodeMethod('scrollTo')
      let raf = null
      let offsetX = 0
      timelineLookaheadOffset.updates.watch(x => {
        offsetX = x
        if (!raf)
          raf = requestAnimationFrame(() => {
            raf = requestAnimationFrame(() => {
              raf = null
              const offset = (offsetX - VISIBLE_SIZE) | 0
              scrollTo({
                top: 0,
                left: offset,
                behavior: 'smooth'
              })
            })
          })
      })
      // requestAnimationFrame(() => {
      //   VISIBLE_SIZE = node.getBoundingClientRect().width
      // })
      data({timelineEntries: true})
      style({
        prop: {
          gridRow: timelineRows.map(list => `span ${list.length + 1}`)
        }
      })
      h('div', () => {
        h('div', () => {
          data({timelineLegend: true})
          h('svg', () => {
            attr({height: 20, width: timelineLookaheadOffset})
            h('path', {
              attr: {d: timelineLegend, fill: 'transparent', stroke: 'black'}
            })
            h('path', {
              attr: {
                d: timelineLegendSmall,
                fill: 'transparent',
                stroke: 'black'
              }
            })
          })
        })
        ScrollLookahead()
        list({source: timelineItems, key: 'id'}, ({store, signal}) => {
          const position = combine(
            {getOffset, entry: store},
            ({getOffset, entry}) => getOffset(entry)
          )
          const {x, y} = reshape(position, signal, {
            x: ({x}) => x | 0,
            y: ({y}) => y | 0
          })
          h('div', () => {
            data({timelineEntry: true})
            style({
              prop: {
                transform: combine(
                  {x, y},
                  ({x, y}) => `translate(${x}px, ${y}px)`
                )
              }
            })
            HighlightValue(
              store.map(({value}) => (Object(value) === value ? 'JSON' : value))
            )
          })
        })
      })
    })
  })

  function ScrollLookahead() {
    h('div', {
      data: {timelineEntry: 'scroll-reference'},
      text: ' ',
      style: {
        prop: {
          transform: timelineLookaheadOffset.map(x => `translate(${x}px, 0px)`)
        }
      }
    })
  }
}
